import { render, staticRenderFns } from "./cjwt.vue?vue&type=template&id=cc88fc6c&scoped=true&"
import script from "./cjwt.vue?vue&type=script&lang=js&"
export * from "./cjwt.vue?vue&type=script&lang=js&"
import style0 from "./cjwt.vue?vue&type=style&index=0&id=cc88fc6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc88fc6c",
  null
  
)

export default component.exports